import { Box } from "@chakra-ui/react"
import { SystemStyleObject } from "@chakra-ui/styled-system"

const MenuIcon = ({ sx }: { sx?: SystemStyleObject }): JSX.Element => (
  <Box sx={sx}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-menu"
    >
      <path d="M3 12h18M3 6h18M3 18h18" />
    </svg>
  </Box>
)

export default MenuIcon
